module.exports = __webpack_public_path__ + "img/achievement_22.023b7596.png";